import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { DynamicDialogComponent } from './dynamic-dialog.component';

@Injectable()
export class DynamicDialogService {
  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<DynamicDialogComponent>;

  /**
   * Opens confirm dialog service
   * @param options
   */
  public open(options): void {
    this.dialogRef = this.dialog.open(DynamicDialogComponent, {
      data: {
        title: options.title,
        message: options.message,
        cancelText: options.cancelText,
        confirmText: options.confirmText,
        iconSrc: options.iconSrc,
        spinner: options.spinner, //loading spinner
        disableClose: options.disableClose
      },
      id: options.id,
      disableClose: options.disableClose,
      autoFocus: false,
      height: 'auto',
      width: '600px'
    });
  }
  public confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(
      take(1),
      map(res => {
        return { closed: res, id: this.dialogRef.id };
      })
    );
  }

  public replaceContent(options) {
    this.dialogRef.close();
    this.open(options);
  }

  public close() {
    this.dialogRef.close();
  }
}
